/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { EntityType } from 'app/shared/model/enumerations/entity-type.model';
import { BusinessType } from 'app/shared/model/enumerations/business-type.model';
import { createEntity, getEntity, reset, updateEntity } from './facility-location.reducer';

export const FacilityLocationUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const facilityLocationEntity = useAppSelector(state => state.facilityLocation.entity);
  const loading = useAppSelector(state => state.facilityLocation.loading);
  const updating = useAppSelector(state => state.facilityLocation.updating);
  const updateSuccess = useAppSelector(state => state.facilityLocation.updateSuccess);
  const entityTypeValues = Object.keys(EntityType);
  const businessTypeValues = Object.keys(BusinessType);

  const handleClose = () => {
    navigate(`/facility-location${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }

    const entity = {
      ...facilityLocationEntity,
      ...values,
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          facilityType: 'LAB',
          locationType: 'LAB',
          businessType: 'B2B',
          ...facilityLocationEntity,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.facilityLocation.home.createOrEditLabel" data-cy="FacilityLocationCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.facilityLocation.home.createOrEditLabel">Create or edit a FacilityLocation</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="facility-location-id"
                  label={translate('tinyMedicRestApp.facilityLocation.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.facilityLocation.active')}
                id="facility-location-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.facilityLocation.revoked')}
                id="facility-location-revoked"
                name="revoked"
                data-cy="revoked"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.facilityLocation.timestampentry')}
                id="facility-location-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.facilityLocation.microSec')}
                id="facility-location-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.facilityLocation.lastupdated')}
                id="facility-location-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.facilityLocation.cursor')}
                id="facility-location-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.facilityLocation.facilityType')}
                id="facility-location-facilityType"
                name="facilityType"
                data-cy="facilityType"
                type="select"
              >
                {entityTypeValues.map(entityType => (
                  <option value={entityType} key={entityType}>
                    {translate(`tinyMedicRestApp.EntityType.${entityType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.facilityLocation.facilityId')}
                id="facility-location-facilityId"
                name="facilityId"
                data-cy="facilityId"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.facilityLocation.locationType')}
                id="facility-location-locationType"
                name="locationType"
                data-cy="locationType"
                type="select"
              >
                {entityTypeValues.map(entityType => (
                  <option value={entityType} key={entityType}>
                    {translate(`tinyMedicRestApp.EntityType.${entityType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.facilityLocation.locationId')}
                id="facility-location-locationId"
                name="locationId"
                data-cy="locationId"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.facilityLocation.businessType')}
                id="facility-location-businessType"
                name="businessType"
                data-cy="businessType"
                type="select"
              >
                {businessTypeValues.map(businessType => (
                  <option value={businessType} key={businessType}>
                    {translate(`tinyMedicRestApp.BusinessType.${businessType}`)}
                  </option>
                ))}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/facility-location" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default FacilityLocationUpdate;
